export const COMPONENT_NAME = "admin-kyc-kyb-participant";
